import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import * as FPT from '../utility/fpt';
import TemplateData from '../utility/getTemplateData';
import { localsMessages } from '../utility/getTemplateData';
import { sanitize } from '../utility/domUtils';
import { Link } from '@paypalcorp/pp-react';

const messages = localsMessages('common/cancelAndReturn');

class CancelAndReturn extends React.Component {
  constructor() {
    super();
    const { label: { return: returnLabel = '' } = {} } = messages || {};
    this.state = {
      returnLabel: returnLabel,
      displayMe: TemplateData.charityCancelUrl ? true : false,
    };
  }

  handleCancel = () => {
    FPT.trackLinkClick('cancel');
    let cancelurl = TemplateData.charityCancelUrl;
    if (cancelurl.indexOf('http') != 0 && cancelurl.indexOf('//') != 0) {
      cancelurl = '//' + cancelurl;
    }
    window.location.href = cancelurl;
  };

  render() {
    let labelreturn = this.state.returnLabel;
    labelreturn = labelreturn.replace(
      '{orgName}',
      sanitize(TemplateData.donationName)
    );

    return (
      <div>
        {this.state.displayMe && (
          <div className="ppvx_col-sm-12 text-center pp_cancel_btn_wrapper">
            <Link
              href="#"
              className="pp_cancel_btn"
              data-testid="cancel-return-button"
              id="cancelReturnBtn"
              onClick={this.handleCancel}
              dangerouslySetInnerHTML={{ __html: labelreturn }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default CancelAndReturn;
